import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a292c05e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "dt__map"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "dt__map-header" }
const _hoisted_4 = { class: "dt__map-header-title" }
const _hoisted_5 = { class: "block-titleSmall block-titleSmall_btnNavBack block-titleSmall_overflowText mb0" }
const _hoisted_6 = { class: "block-titleSmall__info" }
const _hoisted_7 = { class: "dt__map-header-nav" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dt-listIcon" }, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "К списку", -1 /* HOISTED */))
const _hoisted_10 = { class: "dt__map-map" }
const _hoisted_11 = { class: "dt__map-map-control dt__map-map-control_item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dt-listIcon" }, null, -1 /* HOISTED */))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "К списку", -1 /* HOISTED */))
const _hoisted_14 = { class: "dt__map-dataFrame_desktop" }
const _hoisted_15 = {
  key: 0,
  class: "dt__map-dataFrame"
}
const _hoisted_16 = { class: "dt__map-dataFrame-previewCard" }
const _hoisted_17 = { class: "dt__map-dataFrame-previewCard-head" }
const _hoisted_18 = { class: "dt__map-dataFrame-previewCard-wrapper" }
const _hoisted_19 = { class: "dt__map-dataFrame_mobile" }
const _hoisted_20 = { class: "cupertino-pane" }
const _hoisted_21 = { class: "dt__map-dataFrame" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "dt__map-dataFrame-arrow",
  width: "36",
  height: "5",
  viewBox: "0 0 36 5",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "36",
    height: "5",
    rx: "2.5",
    fill: "#CCCCCC"
  })
], -1 /* HOISTED */))
const _hoisted_23 = { class: "dt__map-dataFrame-previewCard" }
const _hoisted_24 = { class: "dt__map-dataFrame-previewCard-head" }
const _hoisted_25 = { class: "dt__map-dataFrame-previewCard-wrapper" }
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_item_list_filter = _resolveComponent("item-list-filter")!
  const _component_map_item = _resolveComponent("map-item")!
  const _component_preview_card = _resolveComponent("preview-card")!
  const _component_skeleton_map = _resolveComponent("skeleton-map")!

  return ($data.page)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  class: "block-btnNavBack",
                  to: {name: 'category-map', params: {categoryUrlName: this.pageIdentity.categoryUrlName}}
                }, null, 8 /* PROPS */, ["to"]),
                _createTextVNode(" " + _toDisplayString(this.page.name.name) + " ", 1 /* TEXT */),
                _createElementVNode("span", _hoisted_6, "(" + _toDisplayString(this.page.categoryName) + ")", 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_item_list_filter, {
                filters: this.page.filters,
                onApply: $options.onApplyFilter,
                onReset: $options.onResetFilter
              }, null, 8 /* PROPS */, ["filters", "onApply", "onReset"]),
              _createVNode(_component_router_link, {
                to: { name: 'page', params: { categoryUrlName: this.pageIdentity.categoryUrlName, pageUrlName: this.pageIdentity.pageUrlName }},
                class: "dt__iconNav"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _hoisted_9
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["to"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(), _createBlock(_component_map_item, {
            key: $data.mapKey,
            objects: this.objects,
            onSelectIds: _cache[0] || (_cache[0] = (ids) => $options.onChoiceElem(ids))
          }, null, 8 /* PROPS */, ["objects"])),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_item_list_filter, {
              filters: this.page.filters,
              onApply: $options.onApplyFilter,
              onReset: $options.onResetFilter
            }, null, 8 /* PROPS */, ["filters", "onApply", "onReset"]),
            _createVNode(_component_router_link, {
              to: { name: 'category', params: { categoryUrlName: this.pageIdentity.categoryUrlName }},
              class: "dt__iconNav"
            }, {
              default: _withCtx(() => [
                _hoisted_12,
                _hoisted_13
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["to"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (this.showPageItemCards)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("span", null, "Найдено: " + _toDisplayString(this.items.length), 1 /* TEXT */),
                      _createElementVNode("div", {
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (this.showPageItemCards = !this.showPageItemCards)),
                        class: "dt-closeIcon"
                      })
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item) => {
                        return (_openBlock(), _createBlock(_component_preview_card, {
                          item: item,
                          "is-adaptive": true,
                          "page-identity": this.pageIdentity
                        }, null, 8 /* PROPS */, ["item", "page-identity"]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ])
                  ])
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("span", null, "Найдено: " + _toDisplayString(this.items.length), 1 /* TEXT */),
                    _createElementVNode("div", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.onHideCupertino && $options.onHideCupertino(...args))),
                      class: "dt-closeIcon"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.items, (item) => {
                      return (_openBlock(), _createBlock(_component_preview_card, {
                        item: item,
                        "is-adaptive": true,
                        "page-identity": this.pageIdentity
                      }, null, 8 /* PROPS */, ["item", "page-identity"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_26, [
        _createVNode(_component_skeleton_map)
      ]))
}